import React, { useEffect } from "react";
import * as ACTION from "../services/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@mui/lab";
import { Dialog } from "primereact/dialog";
import { Typography } from "@mui/material";

export default function StatusTimeline({ payment, onClose }) {
  const dispatch = useDispatch();
  const receiptData = useSelector((state) => state?.receiptState?.data || {});

  useEffect(() => {
    if (payment) {
      console.log("Fetching receipt data for payment:", payment.order_id);
      dispatch({
        type: `${ACTION.RECEIPT}_GET`,
        payload: `/payment/timeline/${payment.order_id}/`,
      });
    }
  }, [payment]);

  console.log("ReceiptData new:", receiptData);

  if (!payment) return null; // Prevent rendering if no payment is selected

  const updateTimeline = (data) => {
    let out = <></>;
    let out1=<></>;
    if (data?.payment?.payment_status) {
      out = (
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="success" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <div>
              <strong>Payment time:</strong>{" "}
              {new Date(
                data?.payment?.created_at
              ).toLocaleTimeString()}
            </div>
            <div>
              <strong>Status:</strong>
              {data?.payment?.payment_status}
            </div>
          </TimelineContent>
        </TimelineItem>
      );
    }
    if (data?.cbs?.report) {
      const report = JSON.parse(data.cbs.report);
      
     out1= <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="success" />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div>
              <strong>Receipt Date:</strong>
              {new Date(data?.cbs?.created_at).toLocaleTimeString()}
            </div>
            <div>
              <strong>Status:</strong> {report.status}
            </div>
            <div>
              <strong>Transaction ID:</strong> {report.transactionID}
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>;
    }
    return <>{out}{out1}</>
  };

  return (
    <Dialog
      header="Payment Status"
      visible
      onHide={onClose}
      style={{ width: "100vw" }}
    >
      <Typography variant="h6" align="center" gutterBottom>
        Order ID: {payment.order_id}
      </Typography>
      <Timeline position="alternate">
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="secondary" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <div>
              <div>
                <strong>Order Created:</strong>{" "}
                {new Date(
                  receiptData.data?.order?.created_at
                ).toLocaleTimeString()}
              </div>
              <div>
                <strong>Status:</strong>
                {receiptData.data?.order?.status}
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>
{
  updateTimeline(receiptData.data)
}
      </Timeline>
    </Dialog>
  );
}
